import { LUCKY_EVENTS, LUCKY_DATA_SOURCE } from '@/packages/components/hook/useLucky'
/**
 * 组件信息
 */
export const info = {
  name: 'xy-lucky-grid', // 组件名
  type: 'component-business', // 组件类型
  label: '幸运转盘2', // 组件label
  icon: 'icon-xy-lucky-grid', // 组件图标
  defaultWidth: 750, // 组件默认宽度
  defaultHeight: 750 // 组件默认宽度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  width: { type: Number, default: 500 }, // 转盘宽度
  height: { type: Number, default: 500 }, // 转盘高度
  prizeWidth: { type: Number, default: 120 }, // 奖项宽度
  prizeHeight: { type: Number, default: 120 }, // 奖项高度
  buttonWidth: { type: Number, default: 200 }, // 按钮宽度
  buttonHeight: { type: Number, default: 200 }, // 按钮高度
  buttonSrc: { type: String, default: '' }, // 按钮图片
  blocksBackgroundColor: { type: String, default: '' }, // 背景颜色
  prizesBorderRadius: { type: Number, default: 60 }, // 圆角
  prizesBackgroundColor: { type: String, default: '#bac5ee' }, // 奖项背景颜色
  prizesBackgroundSrc: { type: String, default: '' }, // 奖项背景图片
  prizesActiveBackgroundColor: { type: String, default: '#f7cf9f' }, // 奖项选中背景颜色
  prizesActiveBackgroundSrc: { type: String, default: '' }, // 奖项选中背景图片
  prizesOffsetAngle: { type: Number, default: 0 }, // 奖项偏移
  speed: { type: Number, default: 20 }, // 旋转速度
  accelerationTime: { type: Number, default: 1500 }, // 开始旋转事件
  decelerationTime: { type: Number, default: 1500 }, // 缓慢停止时间
  activityId: { type: String, default: '' }, // 活动id
  prizes: { type: Array, default: [] }, // 奖品列表
  prizeImages: { type: Object, default: {} }, // 奖品图片
  showCheckBox: { type: Boolean, default: true }, // 是否展示勾选项
  checkBoxTop: { type: Number, default: 10 }, // 复选框距离顶部距离
  checkBoxColor: { type: String, default: '#beabec' }, // 复选框颜色
  checkBoxSrc: { type: String, default: '' }, // 勾选框图片
  checkBoxSelectSrc: { type: String, default: '' }, // 勾选框选中图片
  dialogUUID: { type: String, default: '' }, // 弹窗uuid
  blankPrizesNumber: { type: Number, default: 0 } // 空奖品数量
}

/**
 * 组件开放方法事件
 */
export const events = LUCKY_EVENTS

/**
 * 组件开放数据源
 */
export const dataSource = LUCKY_DATA_SOURCE

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-lucky-grid' // 表单组件
  }
]
